import t from "./toPropertyKey.mjs";
function a(n, e, r) {
  return e = t(e), e in n ? Object.defineProperty(n, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = r, n;
}
export {
  a as default
};
//# sourceMappingURL=defineProperty.mjs.map
